import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // Put new initial states in here
  userEmail: null,
  userId: null,
  qrCodeId: null,
};

export const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setUserEmail: (state, action) => {
      state.userEmail = action.payload;
    },
    setUserId: (state, action) => {
      state.userId = action.payload;
    },
    setQRCodeId: (state, action) => {
      state.qrCodeId = action.payload;
    },
  },
});

export const { setUserEmail, setUserId, setQRCodeId } = globalSlice.actions;

export default globalSlice.reducer;
